import type { BodyRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type TrackRecentSearchRequestBody = { recent_search: { id: string; type: string } };

export const trackRecentSearch = async ({ body }: BodyRequest<TrackRecentSearchRequestBody>) =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.recentSearches.create, {
    body,
  });
